import React, { useEffect } from "react";
import { Container, ContainerFunc } from "../Container/index";
import "./style.css";
import CopyRatesFunc from "./func";
import { MainProvider } from "../../context/MainContext";
import { useLogin } from "../../context/LoginContext";

const CopyRates = () => {
  const { loginData } = useLogin();
  const url = "copy_rates.php";

  // Bind delegated jQuery handlers only after #box-container has mounted.
  // Binding during render targets an empty jQuery collection after a refresh.
  useEffect(() => {
    CopyRatesFunc.event(loginData);
  }, [loginData]);

  return (
    <MainProvider url={url}>
      <Container url={url} />
    </MainProvider>
  );
};

export default CopyRates;
